import { Component, OnInit } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { bootstrapArrowsAngleContract, bootstrapArrowsAngleExpand } from '@ng-icons/bootstrap-icons';
import { provideIcons } from '@ng-icons/core';
import { ContainerJobSearchFormComponent } from './container-job-search-form/container-job-search-form.component';
import { ContainerJobItemStatusComponent } from './container-job-item-status/container-job-item-status.component';
import { ContainerJobLegStatusComponent } from './container-job-leg-status/container-job-leg-status.component';
import { IRootState } from '../../../app.config';
import { Store } from '@ngrx/store';
import { selectUserType } from '../../../../shared/app-configuration/app-configuration.reducer';
import { UserType } from '../../../../shared/app-configuration/models/UserType';

@Component({
  selector: 'app-containers-home-view',
  standalone: true,
  imports: [NgbNavModule, ContainerJobSearchFormComponent, ContainerJobItemStatusComponent, ContainerJobLegStatusComponent],
  templateUrl: './containers-home-view.component.html',
  styleUrl: './containers-home-view.component.scss',
  viewProviders: [
    provideIcons({
      bootstrapArrowsAngleContract,
      bootstrapArrowsAngleExpand,
    })
  ]
})
export class ContainersHomeViewComponent implements OnInit{
  active = 1;
  userType: UserType | null = null;
  constructor(
    private store$: Store<IRootState>,
  ) { }

  ngOnInit(): void {
    this.store$.select(selectUserType).subscribe((userType) => {
      this.userType = userType;
    });
  }

  isSubUser = (): boolean => this.userType === UserType.Subcontractor;
  isFreightUser = (): boolean => this.userType === UserType.FreightPayer;
}
